export default __webpack_public_path__ + "static/media/B_lopetus9.05eba286.mp3";